import { Tabs, Space, Modal, Form, Input, Button, Select, Card, Table, Image, Row, Col, Tooltip, message } from "antd";
import { SearchOutlined, ReloadOutlined,DownloadOutlined,PlusOutlined,ExclamationCircleOutlined, CloudUploadOutlined, ImportOutlined, DeleteOutlined } from "@ant-design/icons";
import service from "../../../@services";
import { useEffect, useState } from "react";
import * as Utils from '../../../@utils';
import useChooseStore from "../hooks/useChooseStore"
import BatchUploadModal from "../components/BatchUpload";
import UploadHistory from "../components/UploadHistory";
import AuthComponent from "../../../components/AuthComponent";
const statusMap = {
  '0':"下架",
  '1': "上架",
  '2': "紧急下架",
  '3': "草稿",
}
const typeMap = {
  '0':"标品",
  '1': "非标准商品",
  '2': "购物袋",
  '3': "加工服务",
  '4': "堂食商品",
}
const { TabPane } = Tabs;
export default function ProductMerchant(props) {
  const [form] = Form.useForm();
  // form.setFieldsValue({haveMainPic: null});
  const [selectedRowKeys, onSelectChange] = useState([])
  const [historyModalVisible, setUploadHistoryVisible] = useState(false)
  const [tabActiveKey, setTabActiveKey] = useState()
  const [loading, setLoading] = useState(false)
  const [batchUploadProps, setBatchUpload] = useState({visible:false})
  const [tabsCount, setTabsCount] = useState({initialCount:'',onShelvesCount:'',offShelvesCount:''})
  const [tableData, setTableData] = useState([])
  const [pagination, setPagination] = useState({current: 1,pageSize: 10,})
  const { chooseStore } = useChooseStore()
  useEffect(() => {
    onSearch()
  }, [tabActiveKey]);
  const onSearch = () => {
    onSelectChange([])
    const params = Object.assign({},form.getFieldsValue(),{ pageIndex: 1, pageSize: 10})
    fetchData(params)
  }
  const onReset = () => {
    form.resetFields();
    // form.submit();
  };
  const handleTableChange = (pagination) => {
    setPagination(pagination)
    const params = Object.assign({},form.getFieldsValue(),{ pageIndex: pagination.current, pageSize: pagination.pageSize})
    fetchData(params)
  }
  const fetchData = async (params) => {
    params.onShelves = parseInt(tabActiveKey)
    setLoading(true)
    const data = await service.product.getMerchantProductList(params)
    setLoading(false)
    if(data){
      setTableData(data.list.result)
      setTabsCount({
        initialCount: data.initialCount,
        onShelvesCount: data.onShelvesCount,
        offShelvesCount: data.offShelvesCount,
      })
      setPagination({
        current: data.list.pageIndex,
        pageSize: data.list.pageSize,
        total: data.list.recordCount
      })
    }
  }
  const deleteProduct = async (skuId) => {
    Modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确认要删除吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: async ()=>{
        await service.product.deleteMerchantProduct(skuId)
        message.success('操作成功');
        onSearch()
      }
    });
  };
  const multipleDelete = async () => {
    if(selectedRowKeys.length===0){
      message.warning('请选择商品');
      return
    }
    Modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确认要删除吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: async ()=>{
        await service.product.batchDeleteMerchantProduct({skuIds:selectedRowKeys})
        message.success('操作成功');
        onSearch()
      }
    });
  };
  const shelvesUpdate = async (skuId,onShelves) => {
    if(!skuId&&selectedRowKeys.length===0){
      message.warning('请选择商品');
      return
    }
    const skuIds = skuId?[skuId]:selectedRowKeys
    Modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: `确认要${onShelves==1?'上架':'下架'}吗？`,
      okText: '确认',
      cancelText: '取消',
      onOk: async ()=>{
        onShelves == 1
        ? await service.product.onShelvesUpdate({skuIds})
        : await service.product.downShelvesUpdate({skuIds})
        message.success('操作成功');
        onSearch()
      }
    });
  };
  const pushStore = async (skuId) => {
    if(!skuId&&selectedRowKeys.length===0){
      message.warning('请选择商品');
      return
    }
    const skuIds = skuId?[skuId]:selectedRowKeys
    chooseStore().then(async (data)=>{
      await service.product.createForStore({skuIds,storeIds:data.storeIds})
      message.success('操作成功');
      onSearch()
    })
  };
  const createProduct = () => {
    props.history.push("/product/create?type=merchant")
  };
  const editProduct = (skuId) => {
    props.history.push(`/product/edit?type=merchant&skuId=${skuId}`)
  };
  const viewProduct = (skuId) => {
    props.history.push(`/product/detail?type=merchant&skuId=${skuId}`)
  };
  const batchUploadImage = () => {
    if(selectedRowKeys.length===0){
      message.warning('请选择商品');
      return
    }
    setBatchUpload({visible:true, taskType: -1})
  };
  const exportProduct = async () => {
    const params = Object.assign({},form.getFieldsValue(),{onShelves: tabActiveKey})
    const file = await service.product.exportMerchantProduct(params)
    const filename = '商家商品报表' + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
    Utils.download(file, filename)
  };
  const onTabChange = (key) => {
    setTabActiveKey(key)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const columns = [
    {
      title: '商品主图',
      dataIndex: 'mainPictureUrl',
      key: 'mainPictureUrl',
      width: '150px',
      textWrap: 'word-break',
      render: (mainPictureUrl) => (
        <Image
          width={59}
          src={mainPictureUrl||'/assets/error-img.png'}
        />
      )
    },
    {
      title: '商品信息',
      dataIndex: '',
      key: 'productInfo',
      render: (text,record,index) => (
        <>
          <Row style={{color: '#3e9eff'}}>商品名称：{record.name}</Row>
          <Row>商品编码：{record.outProductNo}</Row>
          <Row>商品条码：{record.barcode}</Row>
        </>
      )
    },
    {
      title: '规格',
      dataIndex: '',
      key: 'specification',
      width: '255px',
      render: (text,record) => (
        <>
          <Row>规格：{record.specification}</Row>
          <Row>单位：{record.packageUnitName}</Row>
        </>
      )
    },
    {
      title: '价格',
      dataIndex: 'retailPrice',
      key: 'retailPrice',
      render: (text,record) => <span>零售指导价：{record.retailPrice}</span>
    },
    {
      title:'商品类型',
      dataIndex: 'type',
      key: 'type',
      render: (text,record) => typeMap[record.type]
    },
    {
      title:'在售门店',
      dataIndex: 'saleStoreCount',
      key: 'saleStoreCount',
      render: (text,record) =>(
        <>
          在售门店：{record.saleStoreCount}
          {
            record.saleStoreCount>0?
              <Tooltip
                title={
                  <>
                    <div>{record.saleStores}</div>
                  </>
                }
                trigger="click"
              >
                <Button type="link" style={{width: "40px"}}>查看</Button>
              </Tooltip>:""
          }
        </>
      )
    },
    {
      title:'商家状态',
      dataIndex: 'onShelves',
      key: 'onShelves',
      render: (text,record) =>  <div>状态：{statusMap[record.onShelves]}</div>
    },
    {
      title: '操作',
      width: '150px',
      textWrap: 'word-break',
      dataIndex: '',
      key: 'x',
      render: (text,record,index) => (
        <Space style={{flexWrap: 'wrap'}}>
          {
            record.onShelves === 1 ?
            <AuthComponent authKey="/product/merchant-product/down-shelves">
            <Button onClick={()=>shelvesUpdate(record.skuId,0)} type="link">商家下架</Button>
            </AuthComponent> :
            <AuthComponent authKey="/product/merchant-product/on-shelves">
            <Button onClick={()=>shelvesUpdate(record.skuId,1)} type="link">商家上架</Button>
            </AuthComponent>
          }
          <AuthComponent authKey="/product/merchant-product/detail/{skuId}">
            <Button onClick={()=>viewProduct(record.skuId)} type="link">详情</Button>
                </AuthComponent>
            <AuthComponent authKey="/product/merchant-product/update">
            <Button onClick={()=>editProduct(record.skuId)} type="link">编辑</Button>
                </AuthComponent>
          {
            record.onShelves != 1 &&
            <AuthComponent authKey="/product/merchant-product/delete/{skuId}">
              <Button onClick={()=>deleteProduct(record.skuId)} type="link">删除</Button>
            </AuthComponent>
          }
          {
            record.onShelves === 1 &&
            <AuthComponent authKey="/product/merchant-product/create-for-store">
              <Button onClick={()=>pushStore(record.skuId)} type="link">下发门店</Button>
            </AuthComponent>
          }

        </Space>
      ),
    },
  ];
  return (
    <Space
      direction="vertical"
      style={{ width: "100%", display: "flex", flexDirection: "column" }}
    >
      <Card>
        <Form
          form={form}
          layout="inline"
          onReset={onReset}
          initialValues={{ haveMainPic: null }}
        >
          <Form.Item name="productInfo" label="商品信息">
            <Input style={{ width: 200 }} placeholder="商品名称/条码/商品编码" />
          </Form.Item>
          <Form.Item name="haveMainPic" label="商品主图">
            <Select style={{ width: 200 }}>
              <Select.Option value={null}>全部</Select.Option>
              <Select.Option value={true}>有图</Select.Option>
              <Select.Option value={false}>无图</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item>
            <AuthComponent authKey="/product/merchant-product/list">
              <Button type="primary" ghost icon={<SearchOutlined />} onClick={onSearch}>查询</Button>
            </AuthComponent>
          </Form.Item>
          <Form.Item>
            <AuthComponent authKey="/product/merchant-product/list">
              <Button type="primary" ghost icon={<ReloadOutlined />} onClick={onReset}>重置</Button>
            </AuthComponent>
          </Form.Item>
        </Form>
      </Card>
      <Tabs
        style={{marginTop: '-5px', marginBottom: '-23px'}}
        defaultActiveKey={tabActiveKey}
        onChange={onTabChange}
      >
        <TabPane tab="全部" key=""></TabPane>
        <TabPane tab={"草稿("+tabsCount.initialCount+")"} key={3}></TabPane>
        <TabPane tab={"已上架("+tabsCount.onShelvesCount+")"} key={1}></TabPane>
        <TabPane tab={"已下架("+tabsCount.offShelvesCount+")"} key={0}></TabPane>
      </Tabs>
      <Space style={{ display: "flex", justifyContent: "space-between", background: "#ffffff", padding: "15px", marginBottom: "-10px" }}>
        <Space>
        <AuthComponent authKey="/product/merchant-product/create">
          <Button type="primary" onClick={createProduct} icon={<PlusOutlined />}>新建</Button>
        </AuthComponent>
        <AuthComponent authKey="/product/merchant-product/add-file-task">
        <Button type="primary" onClick={()=>setBatchUpload({visible:true,taskType: 1})} icon={<ImportOutlined />}>批量导入</Button>
        </AuthComponent>
        {
        (tabActiveKey === "0" || tabActiveKey === "3")&&
        <AuthComponent authKey="/product/merchant-product/on-shelves">
        <Button type="primary" onClick={()=>shelvesUpdate(null,1)}>批量上架</Button>
        </AuthComponent>
        }
        {
        tabActiveKey === "1" &&
        <AuthComponent authKey="/product/merchant-product/down-shelves">
        <Button type="primary" onClick={()=>shelvesUpdate(null,0)}>批量下架</Button>
        </AuthComponent>
        }
        {
        (tabActiveKey === "0" || tabActiveKey === "3") &&
        <AuthComponent authKey="/product/merchant-product/batch-delete">
          <Button type="primary" onClick={multipleDelete} icon={<DeleteOutlined />}>批量删除</Button>
        </AuthComponent>
        }
        {
        tabActiveKey === "1" &&
        <AuthComponent authKey="/product/merchant-product/create-for-store">
          <Button type="primary" onClick={()=>pushStore()}>批量下发门店</Button>
        </AuthComponent>
        }
        <AuthComponent authKey="/product/merchant-product/export">
        <Button type="primary" icon={<DownloadOutlined />} onClick={exportProduct}>导出</Button>
        </AuthComponent>
        </Space>
        <AuthComponent authKey="/product/merchant-product/list">
        <Button type="link" icon={<CloudUploadOutlined />} onClick={()=>setUploadHistoryVisible(true)}>导入记录</Button>
        </AuthComponent>
      </Space>
      <Table
        rowKey={record=>record.skuId}
        dataSource={tableData}
        rowSelection={rowSelection}
        pagination={pagination}
        loading={loading}
        columns={columns}
        onChange={handleTableChange}
      />
      <UploadHistory visible={historyModalVisible} type={[1]} close={()=>{setUploadHistoryVisible(false)}}></UploadHistory>
      <BatchUploadModal visible={batchUploadProps.visible} taskType={batchUploadProps.taskType} close={()=>{setBatchUpload({visible:false})}}/>
    </Space>
  );
}
